import { FreewheelPauseAdConstants } from 'tag/ts/tag/model/FreewheelPauseAdConstants';
import { EmbedType } from 'tag/ts/tag/model/type/embed/EmbedType';
export class FWPauseAdSlotParams {
    #params;
    constructor(embedType) {
        const pauseAdConstants = FreewheelPauseAdConstants.getInstance();
        let slotDimensions;
        switch (embedType) {
            case EmbedType.DESKTOP:
                slotDimensions = pauseAdConstants.desktopSlotDimensions;
                break;
            case EmbedType.HTML5:
                slotDimensions = pauseAdConstants.stvSlotDimensions;
                break;
        }
        this.#params = {
            ...pauseAdConstants.commonSlotParams,
            ...slotDimensions
        };
    }
    get params() {
        return this.#params;
    }
}
